import { useToast } from '../store/toast';

/**
 * Toast — global notification surface. Single message at a time, auto-dismiss
 * after 2.5s. Position and styling match the prototype's `.toast`.
 */
export function ToastHost() {
  const { message, type } = useToast();
  if (!message) return null;
  return (
    <div className={`toast show ${type}`} role="status" aria-live="polite">
      {message}
    </div>
  );
}
